import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import Header from '../Header/header';
import Footer from '../Footer/footer';
import NGLogo from "../../Asset/logo.svg"
import { set } from "date-fns";

const OrderPaymentCompletion = () => {
  const { suborderId } = useParams();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  // use states for logging
  const [step, setStep] = useState(1); // 1: enter mobile, 2: enter OTP
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");
  const [secondMessage, setSecondMessage] = useState("");
  const [showRetry, setShowRetry] = useState(false);
  const [disableVerifyBtn, setDisableVerifyBtn] = useState(false);
  const [eventData, setEventData] = useState(null);
  const [proceedbtn, setProceedbtn] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [showLoader, setShowLoader] = useState(true);

  let MobileNumber;
  let EmailAddress
  let FirstName

  console.log("suborderId from URL:", suborderId);

  useEffect(() => {
    // Check if suborderId is valid
    const findSuborderEvent = async () => {
      setShowLoader(true);
      try {
        const suborderEventResponse = await axios.get(`${process.env.REACT_APP_BASE_URL}/user/sub_order/${suborderId}`, {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
          },
        })
        console.log("Suborder event response:", suborderEventResponse.data);
        setProceedbtn(true);
        findEventData(suborderEventResponse.data.OfferingId)
      } catch (error) {
        let errorMessage = "Some error occurred while fetching order details!";
        
        if (error.response && error.response.status === 400) {
          errorMessage = "This order has expired or does not exist!";
        }
        
        // Show alert and redirect to home page
        alert(errorMessage);
        navigate("/");
        
        console.error("Error fetching suborder event:", error);
      }
      finally {
        setShowLoader(false);
      }
    }
    findSuborderEvent();
  }, [suborderId, navigate]);

  const findEventData = async (offeringId) => {
    try {
      setShowLoader(true);
      const eventResponse = await axios.get(`${process.env.REACT_APP_BASE_URL}/events/${offeringId}/`, {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
      });
      console.log("Event response:", eventResponse.data);
      setEventData(eventResponse.data);
      
      // Redirect to the new OrderPaymentEventPage with event ID and suborder ID
      navigate(`/events/orderpayment/${offeringId}?suborderId=${suborderId}`);
    } catch (error) {
      console.error("Error fetching event data:", error);
      setSecondMessage("Error in fetching the event details!");
    } finally {
      setShowLoader(false);
    }
  }

  // verifying user
  const sendOtp = async () => {
    try {
      setLoader(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/login/OTP`, {
        mobile_number: mobile,
        country_code: "+91"
      });
        setStep(3);
        setMessage("OTP sent successfully");
      
    } catch (error) {
      console.error(error);
      setMessage("Error sending OTP");
    } finally {
      setLoader(false);
    }
  };

  const verifyOtp = async () => {
    try {
      setLoader(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/login/verifyOTP`, {
        mobile_number: mobile,
        otp: otp,
      });
      console.log('response is:', response.data);
      if (response.data.status = "200") {
        const access_token = response.data.AccessToken;
        localStorage.setItem("access_token", access_token);
        setMessage("Login successful");
        fetchUserProfile(access_token, mobile);
        checkOrderCompletion(access_token, response.data.UserId);  // store token or redirect here
        setDisableVerifyBtn(true)
      } else {
        setMessage("Invalid OTP");
      }
    } catch (error) {
      console.error(error);
      setMessage("Error verifying OTP");
      if (error.response && error.response.status === 400) {
        setMessage("User not found. Retry with correct mobile number.");
        setShowRetry(true);
      }
    } finally {
      setLoader(false);
    }
  };

  const fetchUserProfile = async (access_token, mobile) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/users/?mobile_number=${mobile}&limit=10&offset=0`, {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("User profile response:", response.data.users[0]);
      FirstName = response.data.users[0].FirstName;
      MobileNumber = response.data.users[0].MobileNumber; 
      EmailAddress = response.data.users[0].EmailAddress;
      setUserProfile(response.data.users[0]);

    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  }

  // checking order completion
  const checkOrderCompletion = async (access_token, id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/payments/${suborderId}/status`,
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
          },
        }
      );
      console.log("Order completion status:", response.data);

      if (response.data.UserId !== id) {
        setSecondMessage("You are unauthorized for this payment. Use correct mobile number to proceed to payment!");
        setMessage("")
        setShowRetry(true);
        return;
      }
      else {
        if (response.data.PaymentCompleted === true) {
          setSecondMessage("Your Payment for this order is already completed.");
        } else {
          setSecondMessage("Your Payment is not completed yet. Proceeding to checkout...");
          // Optionally, you can call handleCheckout here if you want to initiate checkout immediately
          handleCheckout(access_token);
        }
      }

    } catch (error) {
      console.error("Error in checking order completion:", error);
      setSecondMessage("Error in checking the order payment status.");
    }
  };

  const handleCheckout = async (access_token) => {
    setLoader(true); // Start loader
    try {
      // Perform the checkout API call
      const checkoutResponse = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/checkout/?sub_order_id=${suborderId}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      // Extract RazorpayOrderId and amount for Razorpay payment
      const { RazorpayOrderId, FiatAmount } = checkoutResponse.data;
      console.log("mobile number:", MobileNumber)
      console.log("email:", EmailAddress)
      console.log('name:', FirstName);
      
      // Call Razorpay payment handling function
      handleRazorpayPayment(RazorpayOrderId, FiatAmount);
    } catch (error) {
      console.error("Error during checkout process:", error);
      if (error.response && error.response.status === 403) {
        setSecondMessage("You are member! Please use mobile app to pay.")
      }
    } finally {
      setLoader(false); // Stop loader
    }
  };

  const handleRazorpayPayment = (RazorpayOrderId, amount) => {
    // Convert amount to paise (multiply INR by 100)
    const adjustedAmount = amount * 100;

    // Dynamically create a form to submit to Razorpay Hosted Checkout
    const form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute(
      "action",
      "https://api.razorpay.com/v1/checkout/embedded"
    );
    form.setAttribute("target", "_blank"); // Open in different tab

    // Define form fields dynamically
    const fields = [
      { name: "key_id", value: `${process.env.REACT_APP_RAZORPAY_ID}` }, // Razorpay key ID
      { name: "order_id", value: RazorpayOrderId }, // Order ID from backend
      { name: "amount", value: adjustedAmount }, // Amount in paise
      { name: "currency", value: "INR" },
      { name: "name", value: "Net Gala" },
      { name: "description", value: "Please complete your payment to proceed." },
      { name: "image", value: `${process.env.REACT_APP_HOSTED_URL}/logo.png` },
      { name: "callback_url", value: `${process.env.REACT_APP_BASE_URL}/payment/callback/` },
      { name: "cancel_url", value: `${process.env.REACT_APP_BASE_URL}/payment/cancel` },
      { name: "prefill[name]", value: FirstName }, // Optional pre-fill for name
      { name: "prefill[contact]", value: MobileNumber }, // Optional pre-fill for contact
      { name: "prefill[email]", value: EmailAddress || "" }, // Optional pre-fill for Email
    ];

    // Append fields to the form
    fields.forEach(({ name, value }) => {
      const input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", name);
      input.setAttribute("value", value);
      form.appendChild(input);
    });

    // Append form to the body and submit it automatically
    document.body.appendChild(form);
    form.submit(); // Trigger the redirection to Razorpay
  };



  return (
    <>
      <Header />
      
      {/* Full-page loader during validation and redirect */}
      <div className="flex justify-center items-center min-h-screen pt-16">
        <div className="flex flex-col items-center gap-4">
          <ClipLoader color="var(--medium-purple)" size={50} />
          <p className="text-lg font-manrope text-[var(--medium-purple)]">Validating your order...</p>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default OrderPaymentCompletion;
